/**
 * 색상 팔레트 정의
 * 다크 모드 테마 적용
 */

export const darkTheme = {
  name: '다크 모드',
  primary: '#818cf8',      // indigo-400
  secondary: '#f472b6',    // pink-400
  accent: '#a78bfa',       // violet-400
  background: '#0f172a',   // slate-900
  surface: '#1e293b',      // slate-800
  text: '#f1f5f9',         // slate-100
  textSecondary: '#cbd5e1', // slate-300
};

/**
 * CSS 변수로 색상 팔레트 적용
 */
export const applyColorPalette = (palette) => {
  const root = document.documentElement;
  root.style.setProperty('--color-primary', palette.primary);
  root.style.setProperty('--color-secondary', palette.secondary);
  root.style.setProperty('--color-accent', palette.accent);
  root.style.setProperty('--color-background', palette.background);
  root.style.setProperty('--color-surface', palette.surface);
  root.style.setProperty('--color-text', palette.text);
  root.style.setProperty('--color-text-secondary', palette.textSecondary);
};
